import React from 'react';
import * as signalR from "@microsoft/signalr";

const NotificationCore = React.forwardRef(({ serverUrl, extension, user, token, isAdmin, groupNotif, toastManager, startConnection, children }, ref) => {
    //console.debug("render NotificationCore " + serverUrl);

    const [connectionStatus, setConnectionStatus] = React.useState("disconnected");

    const connectionRef = React.useRef();
    const ringtoneRef = React.useRef();


    React.useImperativeHandle(ref, () => ({
        startConnection: () => {
            //console.debug("START !!!");
            const connect = async () => { await connectToHub(); };
            if (!connectionRef.current || connectionStatus === "disconnected") { connect(); }
        },
        stopConnection: () => {
            //console.debug("STOP !!!");
            if (connectionRef.current) { connectionRef.current.stop(); setConnectionStatus('disconnected'); }
        },
        isConnected: () => connectionRef.current && connectionStatus !== "disconnected"
    }));

    //console.debug(user);
    //console.debug(token);

    const connectToHub = React.useCallback(async () => {
        try {//?extension=${extension}&isAdmin=${isAdmin}
            // Créer une nouvelle connexion
            const newConnection = new signalR.HubConnectionBuilder().withUrl(`${serverUrl}?extension=${groupNotif}&token=${token}&deviceId=${user.connection.deviceId}`, {
                //accessTokenFactory: () => user.connection.deviceId
                //withCredentials: true
                /*headers: {
                    //"Authorization": `Bearer ${token}`,
                    "X-Key": `${user.tenantId}`
                }*/
            })
             .withAutomaticReconnect([0, 2000, 5000, 10000, 15000, 30000]).configureLogging(signalR.LogLevel.Information).build();
            // Configurer les gestionnaires d'événements
            // Notification d'appel
            newConnection.on('ReceiveNotification', (notification) => { console.log('Notification reçue:', notification); /*handleNotification(notification);*/ });
            // Confirmation de connexion
            newConnection.on('ConnectionEstablished', (data) => { console.log('Connexion établie:', data); setConnectionStatus('connected'); toast.success("ConnectionEstablished", data); });
            // Déconnexion forcée
            newConnection.on('ForceDisconnect', (data) => {
                console.log('Déconnexion forcée:', data); toast.warning("ForceDisconnect", data);  
                setTimeout(() => { newConnection.stop(); setConnectionStatus('disconnected'); }, 2000);
            });
            // Message broadcast
            newConnection.on('BroadcastMessage', (message) => { console.log('Message broadcast reçu:', message); toast[message.type || 'info']("BroadcastMessage", message); });
            // Message direct
            newConnection.on('DirectMessage', (message) => { console.log('Message direct reçu:', message); toast[message.type || 'info']("DirectMessage", message, { autoClose: false }); });
            // Gérer la reconnexion
            newConnection.onreconnecting(error => { console.log('Tentative de reconnexion...', error); setConnectionStatus('reconnecting'); toast.info("Reconnecting", { error: error, message: 'Tentative de reconnexion au serveur...' }); });
            newConnection.onreconnected(connectionId => { console.log('Reconnecté avec ID:', connectionId); setConnectionStatus('connected'); toast.success("Reconnected", 'Reconnecté au serveur!'); });
            newConnection.onclose(error => { console.log('Connexion fermée:', error); setConnectionStatus('disconnected'); toast.error("Close", { error: error, message: 'Déconnecté du serveur' }); });
            // Démarrer la connexion
            await newConnection.start();
            console.log('Connexion SignalR établie');
            // Stocker la connexion
            connectionRef.current = newConnection;
            return newConnection;
        } catch (err) {
            console.error('Erreur lors de l\'établissement de la connexion SignalR:', err);
            setConnectionStatus('error');
            //toast.error("Exception", { error: err, message: 'Impossible de se connecter au serveur de notifications' });
            // Réessayer après un délai
            setTimeout(connectToHub, 30000);
            return null;
        }
    }, [extension, isAdmin, serverUrl]);

    // Connecter au démarrage et nettoyer à la fermeture  
    React.useEffect(() => {
        // Ne pas se connecter si l'extension n'est pas définie
        //if (!extension) return;
        if (startConnection) {
            const connect = async () => { await connectToHub(); };
            connect();
        }


        const handleBeforeUnload = () => {
            // Your cleanup logic here
            console.log("Cleaning up before page refresh");
            if (connectionRef.current) {
                //console.debug("Destroy connectionRef");
                connectionRef.current.stop(); connectionRef.current = null;
            }
            if (ringtoneRef.current) {
                //console.debug("Destroy ringtoneRef");
                ringtoneRef.current.pause(); ringtoneRef.current = null;
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        // Nettoyage à la fermeture
        return () => {
            //console.debug("Destroy");
            window.removeEventListener("beforeunload", handleBeforeUnload);

            if (connectionRef.current) {
                //console.debug("Destroy connectionRef");
                connectionRef.current.stop(); connectionRef.current = null;
            }
            if (ringtoneRef.current) {
                //console.debug("Destroy ringtoneRef");
                ringtoneRef.current.pause(); ringtoneRef.current = null;
            }
        };
    }, [extension, connectToHub]);

    var toast = toastManager || {
        info: () => {},
        warning: () => {},
        success: () => {},
        error: () => {},
    };

    return children;
});

export default NotificationCore;